<ion-header>
  <ion-toolbar color="primary">
    <ion-buttons slot="primary">
      <ion-button (click)="modalController.dismiss()">
        {{ 'core.done' | translate }}
      </ion-button>
    </ion-buttons>

    <ion-title>{{ 'settings.title' | translate }}</ion-title>

    <ion-buttons slot="secondary">
      <ion-button (click)="share()">
        <ion-icon slot="icon-only" name="share"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content>
  <ion-list>
    <ion-list-header>
      <ion-label>
        <ion-icon name="grid"></ion-icon>
        {{ 'settings.homescreen.title' | translate }}
      </ion-label>
    </ion-list-header>

    <ion-item button (click)="openHomescreenSettings()">
      {{ 'settings.homescreen.tiles' | translate }}
    </ion-item>
  </ion-list>
  <ion-list>
    <ion-list-header>
      <ion-label>
        <ion-icon name="pizza"></ion-icon>
        {{ 'settings.canteen.title' | translate }}
      </ion-label>
    </ion-list-header>

    <ion-item button>
      <ion-toggle  labelPlacement="start" #canteen name="canteen" [checked]="canteenRemember$ | async" (ionChange)="toggleCanteenRemember(canteen)">
        <h5>{{ 'settings.canteen.header' | translate }}</h5>
        <p class="ion-text-wrap">{{ 'settings.canteen.subheader' | translate }}</p>
      </ion-toggle>
    </ion-item>
  </ion-list>

  <ion-list>
    <ion-list-header>
      <ion-label>
        <ion-icon name="train"></ion-icon>
        {{ 'settings.departure.title' | translate }}
      </ion-label>
    </ion-list-header>

    <ion-item button="true">
      <ion-toggle
        #departure
        name="departue"
        [checked]="departureRemember$ | async"
        (ionChange)="toggleDepartureRemember(departure)"
        >
        <h5>{{ 'settings.departure.header' | translate }}</h5>
        <p class="ion-text-wrap">{{ 'settings.departure.subheader' | translate }}</p>
      </ion-toggle>
    </ion-item>
  </ion-list>

  <ion-list>
    <ion-list-header>
      <ion-label>
        <ion-icon name="notifications-outline"></ion-icon>
        {{ 'settings.push.title' | translate }}
      </ion-label>
    </ion-list-header>

    <ion-item button>
      <ion-toggle #push name="push" [checked]="pushEnabled$ | async" (ionChange)="togglePush(push)">
        <h5>{{ 'settings.push.header' | translate }}</h5>
        <p class="ion-text-wrap">{{ 'settings.push.subheader' | translate }}</p>
      </ion-toggle>
    </ion-item>

    <ion-item>
      <ion-label class="ion-text-wrap">
        <h5>{{ 'settings.push.channel.header' | translate }}</h5>
        <p>{{ 'settings.push.channel.subheader' | translate }}</p>
      </ion-label>
    </ion-item>

    <ion-item button>
      <ion-toggle
        #general
        name="general"
        [disabled]="!push.checked"
        [checked]="(pushChannels$ | async)?.general"
        (ionChange)="togglePushChannel(general)"
        >
        {{ 'settings.push.channel.general' | translate }}
      </ion-toggle>
    </ion-item>

    <ion-item button>
      <ion-toggle
        #sports
        name="sports"
        [disabled]="!push.checked"
        [checked]="(pushChannels$ | async)?.sports"
        (ionChange)="togglePushChannel(sports)"
        >
        {{ 'settings.push.channel.sports' | translate }}
      </ion-toggle>
    </ion-item>

    <ion-item button>
      <ion-toggle
        #library
        name="library"
        [disabled]="!push.checked"
        [checked]="(pushChannels$ | async)?.library"
        (ionChange)="togglePushChannel(library)"
        >
        {{ 'settings.push.channel.library' | translate }}
      </ion-toggle>
    </ion-item>

    <ion-item button>
      <ion-toggle
        #healthPassport
        name="healthPassport"
        [disabled]="!push.checked"
        [checked]="(pushChannels$ | async)?.healthPassport"
        (ionChange)="togglePushChannel(healthPassport)"
        >
        {{ 'settings.push.channel.healthPassport' | translate }}
      </ion-toggle>
    </ion-item>

    @if (authService.isAuthenticated()) {
      <ion-item button (click)="sendTestNotification()" [disabled]="!push.checked">
        {{ 'settings.push.sendTestNotification' | translate }}
      </ion-item>
    }
  </ion-list>
  <ion-list>
    <ion-list-header>
      <ion-label>
        <ion-icon name="globe"></ion-icon>
        {{ 'settings.lang.title' | translate }}
      </ion-label>
    </ion-list-header>
    <ion-radio-group [value]="language()" (ionChange)="selectLanguage($event)">
      @for (lang of languages; track lang) {
        <ion-item [class.selected]="language() === lang.lang">
          <ion-radio labelPlacement="start" justify="space-between" [value]="lang.lang">
            {{ lang.translationKey | translate }}
          </ion-radio>
        </ion-item>
      }
    </ion-radio-group>
  </ion-list>

  <ion-list>
    <ion-list-header>
      <ion-label>
        <ion-icon name="information-circle"></ion-icon>
        {{ 'settings.information.title' | translate }}
      </ion-label>
    </ion-list-header>

    <ion-item>
      <ion-label>
        <h2>{{ 'settings.information.appversion' | translate }}</h2>
        @if (appInfo) {
          <h3>{{ appInfo.version }} ({{ appInfo.build }})</h3>
        }
      </ion-label>
    </ion-item>
    <ion-item button (click)="openAccessibility()">
      {{ 'settings.accessibility.title' | translate }}
    </ion-item>
    <ion-item button (click)="openLicenses()">
      {{ 'settings.information.licenses.licensesTitle' | translate }}
    </ion-item>
    <ion-item button (click)="openChangelogs()">
      {{ 'settings.information.changelog' | translate }}
    </ion-item>
    <ion-item button (click)="clearCache()">
      {{ 'settings.information.clearCache.title' | translate }}
    </ion-item>
    <ion-item button (click)="resetApp()">
      {{ 'settings.information.reset.title' | translate }}
    </ion-item>
    <!--
      @if (debug) {
        <ion-item *ngIf="debug" button (click)="exportLogs()">
          {{ 'Logs exportieren' }}
        </ion-item>
      }
    -->
  </ion-list>

  <ion-list>
    @if (authService.isAuthenticated()) {
      <ion-list-header>
        <ion-label>
          <ion-icon name="person"></ion-icon>
          <h3>{{ authService.userProfile()?.givenName }} {{ authService.userProfile()?.familyName }} ({{ authService.userProfile()?.username }})</h3>
        </ion-label>
      </ion-list-header>
      <ion-item button detail="false" lines="none" color="danger" (click)="signout()">
        <ion-label>
          {{ 'settings.signout' | translate }}
        </ion-label>
      </ion-item>
    } @else {
      <ion-list-header>
        <ion-label>
          <ion-icon name="person"></ion-icon>
          <h3>{{ 'auth.signedOut' | translate }}</h3>
        </ion-label>
      </ion-list-header>
      <ion-item button detail="false" lines="none" color="primary" (click)="signin()">
        <ion-label>
          {{ 'auth.loginButton' | translate }}
        </ion-label>
      </ion-item>
    }
  </ion-list>
</ion-content>
